/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Filter_SentInputs */

const cs_signing_filter_sent = /** @type {(inputs: Signing_Filter_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeká`)
};

const en_signing_filter_sent = /** @type {(inputs: Signing_Filter_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

/**
* | output |
* | --- |
* | "Waiting" |
*
* @param {Signing_Filter_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_filter_sent = /** @type {((inputs?: Signing_Filter_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Filter_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_filter_sent(inputs)
	return cs_signing_filter_sent(inputs)
});